import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { IMAGES } from "@/data/constants";
import { useI18n } from "@/context/I18nContext";
import { ArrowLeft } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 progere-bg">
      {/* Left brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden">
        <img src={IMAGES.construction} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-[#050505]" />
        <div className="absolute inset-0 pg-grid-bg opacity-50" />
        <div className="relative">
          <Logo size={44} />
        </div>
        <div className="relative max-w-md">
          <h2 className="text-4xl font-extrabold text-white leading-tight">
            {t("auth.brandA")}
            <span className="text-[#EAB308]">{t("auth.brandB")}</span>
          </h2>
          <p className="mt-4 text-white/60">
            {t("auth.brandDesc")}
          </p>
        </div>
        <div className="relative text-xs font-mono uppercase tracking-[0.25em] text-white/40">
          INNOVER. CONSTRUIRE. PROGÉRER.
        </div>
      </div>

      {/* Right form panel */}
      <div className="relative flex flex-col justify-center px-6 py-12 sm:px-12 lg:px-16">
        <div className="absolute top-6 left-6">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors" data-testid="back-home-link">
            <ArrowLeft className="w-4 h-4" /> {t("auth.back")}
          </Link>
        </div>
        <div className="mx-auto w-full max-w-md">
          <div className="lg:hidden mb-8">
            <Logo size={40} />
          </div>
          <h1 className="text-3xl font-extrabold text-white">{title}</h1>
          <p className="mt-2 text-white/55">{subtitle}</p>
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-white/50">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
